"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDealsAssociationsOptions;

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _AssociationOptionsDependencyHelpers = require("crm_data/associations/AssociationOptionsDependencyHelpers");

var _immutable = require("immutable");

var _DealsSearchAPIQuery = _interopRequireDefault(require("crm_data/deals/api/DealsSearchAPIQuery"));

var _EngagementAssociationsConstants = require("crm_data/associations/EngagementAssociationsConstants");

var _DealsStore = _interopRequireDefault(require("crm_data/deals/DealsStore"));

function getAlreadyAssociatedDeals(values) {
  var dealIds = (0, _AssociationOptionsDependencyHelpers.getIdsFromOptions)(values, 'dealValues');
  var alreadyAssociatedDeals = dealIds ? _DealsStore.default.get(dealIds) : (0, _immutable.List)();
  return (0, _AssociationOptionsDependencyHelpers.parseMatches)(alreadyAssociatedDeals);
}

function getDealsAssociationsOptions(_ref) {
  var objectType = _ref.objectType,
      subjectId = _ref.subjectId,
      subject = _ref.subject,
      state = _ref.state,
      values = _ref.values;
  var debouncedSearchTextForElasticSearch = state.debouncedSearchTextForElasticSearch;
  var alreadyAssociatedDeals = getAlreadyAssociatedDeals(values);
  var dealOptions = [];

  if (objectType === _ObjectTypes.DEAL) {
    dealOptions = (0, _AssociationOptionsDependencyHelpers.parseMatches)((0, _immutable.List)([subject]));
  } else {
    dealOptions = (0, _AssociationOptionsDependencyHelpers.getAssociationsFromAssociationsStore)(objectType, subjectId, objectType + "_TO_DEAL", _ObjectTypes.DEAL);
    var numberOfDeals = dealOptions && dealOptions.length;

    if (numberOfDeals > _EngagementAssociationsConstants.ASSOC_STORE_SEARCH_MAX && (0, _AssociationOptionsDependencyHelpers.hasMinimumSearchText)(debouncedSearchTextForElasticSearch)) {
      var query = _DealsSearchAPIQuery.default.associatedDeal(objectType, subjectId, _EngagementAssociationsConstants.MAX_OPTION_SIZE, debouncedSearchTextForElasticSearch);

      dealOptions = (0, _AssociationOptionsDependencyHelpers.getAssociationsFromElasticSearch)(subjectId, query, _ObjectTypes.DEAL);
    }
  }

  var allDealOptions = (0, _immutable.List)(alreadyAssociatedDeals.concat(dealOptions || [])).reduce(function (map, option) {
    return map.set(option.id, option);
  }, (0, _immutable.Map)()).sortBy(function (match) {
    return match.text.toLowerCase();
  }).toArray();
  return allDealOptions;
}

module.exports = exports.default;